// extracted by mini-css-extract-plugin
export default {"label_spec":"AdminList_label_spec__pRapf","root":"AdminList_root__Rw6NN","tableArea":"AdminList_tableArea__Rj0Ac"};